import { Action } from 'redux';

export interface shiftState {
  loading: boolean;
  shift: boolean | null;
  error: string | null;
}

export const SHIFT_REQUEST = 'SHIFT_REQUEST';
export const SHIFT_SUCCESS = 'SHIFT_SUCCESS';
export const SHIFT_FAILURE = 'SHIFT_FAILURE';

export interface ShiftRequestAction extends Action<typeof SHIFT_REQUEST> {}

export interface ShiftSuccessAction extends Action<typeof SHIFT_SUCCESS> {
  payload: boolean;
}

export interface ShiftFailureAction extends Action<typeof SHIFT_FAILURE> {
  payload: string;
}

export type ShiftActionType =
  | ShiftRequestAction
  | ShiftSuccessAction
  | ShiftFailureAction;
